/**
 * Coach identity panel for inbox.
 */
import React from "react";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";

import { VAvatar, VText } from "form";
import { useAsterController } from "context";
import { asObject, asString } from "utils/safeData";

/**
 * Shows the assigned coach name, avatar, and contact details.
 */
const ChatUserInfo = () => {
  const [controller] = useAsterController();
  const admin = asObject(controller?.admin);

  const displayName =
    `${asString(admin.first_name) || asString(admin.username)} ${asString(admin.last_name)}`.trim() || "Unknown";

  return (
    <Box className="hidden md:block bottom-0 w-96 border-0 border-r border-t border-solid border-gray-300 dark:border-gray-500 dark:border-gray-500 z-10 overflow-y-auto v-light-scrollbar transition-all v-bg-body">
      <Box className="p-7">
        <VText className="text-3xl">Administrator</VText>
        <Box className="flex items-center mt-6">
          <VAvatar src={asString(admin.avatar)} className="w-16 h-16 rounded-full mr-6" />
          <Box>
            <VText className="text-lg" div>
              {displayName}
            </VText>
            <VText color="secondary" className="text-xs bg-gray-100 dark:bg-gray-700 rounded px-1 py-0.5 w-min" div>
              ADMIN
            </VText>
          </Box>
        </Box>
        <Box className="mt-5">
          <VText className="text-lg">Personal Data</VText>
          <Box className="mt-5">
            <Box className="flex items-center">
              <VText color="secondary" className="mr-4" div>
                <Icon icon="fe:mail" className="text-xl" />
              </VText>
              <Box>
                <VText className="text-sm" div>
                  Email
                </VText>
                <VText className="text-sm" color="secondary">
                  {asString(process.env.REACT_APP_CONTACT_EMAIL, "-")}
                </VText>
              </Box>
            </Box>
            <Box className="flex items-center mt-3">
              <VText color="secondary" className="mr-4" div>
                <Icon icon="ant-design:phone-outlined" className="text-xl" />
              </VText>
              <Box>
                <VText className="text-sm" div>
                  Phone Number
                </VText>
                <VText className="text-sm" color="secondary">
                  {asString(admin.phone_number, "-")}
                </VText>
              </Box>
            </Box>
            <Box className="flex items-center mt-3">
              <VText color="secondary" className="mr-4" div>
                <Icon icon="la:id-card" className="text-xl" />
              </VText>
              <Box>
                <VText className="text-sm" div>
                  Role
                </VText>
                <VText className="text-sm" color="secondary">
                  {asString(admin.role, "-")}
                </VText>
              </Box>
            </Box>
            <Box className="flex items-center mt-3">
              <VText color="secondary" className="mr-4" div>
                <Icon icon="akar-icons:location" className="text-xl" />
              </VText>
              <Box>
                <VText className="text-sm" div>
                  Address
                </VText>
                <VText className="text-sm" color="secondary">
                  {asString(admin.location, "-")}
                </VText>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatUserInfo;
